module.exports = __webpack_public_path__ + "img/a1.28eca6f2.svg";